import { render, staticRenderFns } from "./TeamView.vue?vue&type=template&id=15f7ea86&scoped=true&"
import script from "./TeamView.vue?vue&type=script&lang=ts&"
export * from "./TeamView.vue?vue&type=script&lang=ts&"
import style0 from "./TeamView.vue?vue&type=style&index=0&id=15f7ea86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f7ea86",
  null
  
)

export default component.exports